// extracted by mini-css-extract-plugin
export default {"StatisticsSection":"Statistics_StatisticsSection__1daXI","sectionWrapper":"Statistics_sectionWrapper__BMPAK","contentBox":"Statistics_contentBox__cxq-A"};